import { isEmpty } from "lodash";

import { MetricCardProps } from "@/Components/v2/atoms/MetricCard/MetricCard";
import { Stack } from "@/Components/v2/atoms/Stack";
import { MetricCards } from "@/Components/v2/molecule/MetricCards";

type MarketingMetrics = {
  allMetrics: MetricCardProps[][];
};

const MarketingMetrics = ({ allMetrics }: MarketingMetrics) =>
  !isEmpty(allMetrics) ? (
    <Stack direction="column" gap={2} width="100%">
      {allMetrics.map((metrics, index) =>
        !isEmpty(metrics) ? <MetricCards key={index} metrics={metrics} /> : null
      )}
    </Stack>
  ) : null;

export default MarketingMetrics;
